// This file contains all relevant JS functionality for the user account pages

export const myAccount = {
    init: () => {
        console.debug("my-account.js: init");
        $("#customer-form").submit((e) => {
            myAccount.validateSpamField();
        });
    },
    validateSpamField: () => {
        if ($("#username").val()) {
            /*gtag('event', 'Create account spam', {
                'event_category': 'Forms',
                'event_label': 'Submit',
            });*/
            window.dataLayer.push({
                'event': 'Create account spam',
                'event_category': 'Forms',
                'event_label': 'Submit',
            });
            return false;
        }
    }
}